<template><ListFilter field="sample_origin_class" :options="opts" label="Классификация образца" @filter="$emit('filter',$event)" @openDetail="$emit('openDetail',$event)"/></template>
<script>
import ListFilter from './ListFilter.vue'
export default { name:'SampleOriginClassFilter', components:{ListFilter}, data(){ return { opts:['осадочный обломочный','осадочный органогенно-обломочный'] } } }
</script>
